'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertJsonToLinkedList = convertJsonToLinkedList;
exports.autoCompleteFromLinkedList = autoCompleteFromLinkedList;
exports.getAllCheckedNodes = getAllCheckedNodes;
exports.getNodeById = getNodeById;
exports.handleCheckForLinkedList = handleCheckForLinkedList;
exports.uncheckAll = uncheckAll;
exports.getHighestLevelOfCheckedNodes = getHighestLevelOfCheckedNodes;
exports.getAlphabetOrderedFilter = getAlphabetOrderedFilter;
// data need to be an object
/*
  @param: data
  a = {
    name:
    type:
    parent: null
    childrenId: {
      b: {
        name:
        type:
        parentId: 'a' -> will be converted to reference object to tranverse
        children: {}
      }
    }
  }
  To save memory we not gonna mutate the data

  @return array of linked list items

  @TODO: check should be populated from the store since it is not just UI state
*/
function convertJsonToLinkedList(data) {
  var arr = [data];
  data.check = false;

  function convert(node, parent) {
    node.parent = parent;
    node.check = node.check ? node.check : false;
    // hardcode for score and status for now
    if (node.id === 'positive' || node.id === 'negative' || node.id === 'neutral' || node.id === 'B' || node.id === 'D' || node.id === 'A' || node.id === 'BR') {
      node.check = true;
    }
    if (node.children === null || typeof node.children === 'undefined') {
      return;
    }

    for (var prop in node.children) {
      if (node.children.hasOwnProperty(prop)) {
        node.children[prop].parent = parent;
        node.children[prop].check = node.children[prop].check ? node.children[prop].check : false;
        arr.push(node.children[prop]);
        convert(node.children[prop], node);
      }
    }
  }

  for (var prop in data.children) {
    if (data.children.hasOwnProperty(prop)) {
      arr.push(data.children[prop]);
      convert(data.children[prop], data);
    }
  }

  return arr;
}

// copy by reference to save memory
// use array to loop faster O(n) time
function autoCompleteFromLinkedList(dataArr, value) {
  var include = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var result = [];
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = dataArr[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var item = _step.value;

      if (item.name.toLowerCase().indexOf(value.toLowerCase()) !== -1) {
        if (include.length > 0 && item.parent && include.indexOf(item.parent.name) !== -1) {
          result.push(item);
        }
        if (include.length === 0) {
          result.push(item);
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return result;
}

function getAllCheckedNodes(dataArr) {
  var result = [];

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = dataArr[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var item = _step2.value;

      if (item.check === true) {
        result.push(item);
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return result;
}

function getNodeById(node, id) {
  if (node.id === id) {
    return node;
  }
  if (node.children === null || typeof node.children === 'undefined') {
    return null;
  }
  for (var prop in node.children) {
    if (node.children.hasOwnProperty(prop)) {
      getNodeById(node.children[prop], id);
    }
  }
}

// tranverse check/uncheck parent of a node
function checkParent(node, checked) {
  var parent = node;
  if (parent.parent) {
    while (parent.parentId !== null && parent.parent) {
      parent.parent.check = typeof checked !== 'undefined' ? checked : parent.parent.check;
      parent = parent.parent;
    }
  }
  return parent;
}

// tranverse check/uncheck children of a node
function checkChildren(node, checked) {
  if (node.children === null || typeof node.children === 'undefined') {
    return;
  }
  for (var prop in node.children) {
    if (node.children.hasOwnProperty(prop)) {
      node.children[prop].check = checked;
      checkChildren(node.children[prop], checked);
    }
  }
}

/* function checkParentIfAllChildrenChecked(node) {
  let parent = node;
  let check = true;
  while (parent.parent.parentId !== null) {
    for (const prop in parent.parent.children) {
      if (parent.parent.children[prop].check === false) {
        check = false;
      }
    }
    if (check) {
      parent.parent.check = true;
    }
    check = true;
    parent = parent.parent;
  }
} */

// no mutation
// handle check and uncheck for a node filter
function handleCheckForLinkedList(data) {
  var parent = data;
  data.check = !data.check;
  if (data.check) {
    // if check --> check all children node
    parent = checkParent(data);
    checkChildren(data, true);
    // checkParentIfAllChildrenChecked(data);
  } else {
    // if uncheck --> uncheck all children node and parent node
    parent = checkParent(data, false);
    checkChildren(data, false);
  }
  return parent;
}

// uncheck all
function uncheckAll(data) {
  var parent = checkParent(data, false);
  checkChildren(data, false);
  return parent;
}

// get highest level of checked node
function getHighestLevelOfCheckedNodes(filterOriginal) {
  var data = filterOriginal.children && filterOriginal.children.length > 0 ? Object.assign({}, filterOriginal.children[0]) : Object.assign({}, filterOriginal);
  while (data.parent) {
    data = Object.assign({}, data.parent);
  }
  var result = [];

  function goIn(node) {
    if (node.children === null || typeof node.children === 'undefined') {
      return;
    }

    for (var prop in node.children) {
      if (node.children.hasOwnProperty(prop)) {
        if (node.children[prop].check) {
          result.push(node.children[prop]);
        } else {
          goIn(node.children[prop]);
        }
      }
    }
  }

  if (data.check) {
    result.push(data);
  } else {
    for (var prop in data.children) {
      if (data.children.hasOwnProperty(prop)) {
        if (data.children[prop].check) {
          result.push(data.children[prop]);
        } else {
          goIn(data.children[prop]);
        }
      }
    }
  }
  return result;
}

// get array of filter children in alphabet order
function getAlphabetOrderedFilter(filter) {
  var data = Object.assign({}, filter);
  var search = Array.isArray(data.children) ? true : false;
  var keysinorder = [];
  var keysObj = [];
  if (search) {
    keysObj = data.children;
  } else {
    if (data.children && data.children !== null) {
      Object.keys(data.children).forEach(function (key) {
        keysObj.push(data.children[key]);
      });
    }
  }
  keysObj.sort(function (item1, item2) {
    var item1_ = '';
    var item2_ = '';
    if (item1.index && item2.index) {
      item1_ = item1.index;
      item2_ = item2.index;
    } else {
      item1_ = item1.name;
      item2_ = item2.name;
    }
    if (item1_ > item2_) {
      return 1;
    }
    if (item1_ < item2_) {
      return -1;
    }
    return 0;
  });
  keysObj.forEach(function (item, index) {
    if (search) {
      keysinorder.push(index);
    } else {
      keysinorder.push(item.id);
    }
  });
  return keysinorder;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/BinaryCheckBox/BinaryCheckBoxUtil.js
// module id = 2168
// module chunks = 1